// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"59a94099","195":"2af0b745","205":"cba72777","274":"b46c3cdc","353":"f494d570","546":"75843d38","678":"33eb4dd5","885":"7589ca0a","963":"b2f7ff47"}[chunkId] + ".chunk.js";
};